import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const riepilogoDeleteSlice = createSlice({
    name: 'riepilogoDelete',
    initialState,
    reducers: {
        setRiepilogoDelete: (state, { payload }) => {
            return payload;
        },
        resetRiepilogoDelete: (state) => {
            return initialState;
        },
    }
});

export const { setRiepilogoDelete, resetRiepilogoDelete } = riepilogoDeleteSlice.actions;

const { reducer } = riepilogoDeleteSlice;

export default reducer;